import styles from './styles.module.scss';
import { IoDocumentTextOutline } from 'react-icons/io5';

export default function CaseEmpty() {
  return (
    <div className={styles.empty}>
      <IoDocumentTextOutline className={styles.icon} />
      <div>
        <p className={styles.title}>Общая информация</p>
        <p className={styles.subtitle}>Здесь отображается информация о полисе</p>
      </div>
    </div>
  );
}
